const AssignSubjectTeacher = {

    // FIELDS
    "session_id": "Session",
    "course_id": "Course",
    "semester_id": "Semester",
    "subject_id": "Subject",
    "user_id": "Teacher",
    "status": "Status",

    // PAGE HEADER
    "assignSubjectTeacher": "Assign Subject Teacher",

    // ERROR
    "error_session": "Select Session",
    "error_course": "Select Course",
    "error_semester": "Select Semester",
    "error_subject": "Select Subject",
    "error_user": "Select Teacher",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_session": "SESSION",
    "table_course": "COURSE",
    "table_semester": "SEMESTER",
    "table_subject": "SUBJECT",
    "table_user": "TEACHER",
    "table_status": "STATUS"
}

export default AssignSubjectTeacher;
